// Service worker registration with update support.
// Enabled in both dev preview and production; sw.js bypasses HMR endpoints so React hot reload still works.
export function registerServiceWorker() {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;

    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/sw.js")
            .then((reg) => {
                reg.addEventListener("updatefound", () => {
                    const sw = reg.installing;
                    if (!sw) return;
                    sw.addEventListener("statechange", () => {
                        if (sw.state === "activated" && navigator.serviceWorker.controller) {
                            console.info("[SW] new version active");
                        }
                    });
                });
            })
            .catch((err) => console.warn("[SW] registration failed", err));
    });
}
